import { render, staticRenderFns } from "./usehelp.vue?vue&type=template&id=f5dbf064&scoped=true"
import script from "./usehelp.vue?vue&type=script&lang=js"
export * from "./usehelp.vue?vue&type=script&lang=js"
import style0 from "./usehelp.vue?vue&type=style&index=0&id=f5dbf064&prod&scoped=true&lang=css"
import style1 from "./usehelp.vue?vue&type=style&index=1&id=f5dbf064&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dbf064",
  null
  
)

export default component.exports